import React, { useRef } from "react";
import { Modal, Button, Spinner, Form } from "react-bootstrap";

const EfisModalJustificativa = ({
  title,
  body,
  show,
  codigo,
  situacao,
  primaryLabel,
  secondaryLabel,
  loadingConfirmationAction,
  confirmationHandler,
  closeHandler,
}) => {
  const textoJustificativaInputRef = useRef();

  return (
    <Modal show={show} onHide={() => closeHandler()} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{title || "Justificativa"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {typeof body === "string" ? <p>{body}</p> : body}
        <Form.Control ref={textoJustificativaInputRef} autoFocus multiline rows={4} />
      </Modal.Body>
      <Modal.Footer>
        {loadingConfirmationAction ? (
          <Spinner animation="border" role="status" />
        ) : (
          <Button
            variant="primary"
            onClick={() => {
              confirmationHandler(codigo, situacao, textoJustificativaInputRef.current.value);
            }}
          >
            {primaryLabel || "Salvar"}
          </Button>
        )}
        <Button variant="light" onClick={() => closeHandler()}>
          {secondaryLabel || "Cancelar"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EfisModalJustificativa;
